import { useEffect } from "react";

type PublicBrandingOptions = {
  title?: string;
  faviconUrl?: string | null;
};

export function applyPublicBranding({ title, faviconUrl }: PublicBrandingOptions) {
  if (typeof document === "undefined") return;
  if (title) {
    document.title = title;
  }
  if (!faviconUrl) return;
  let link = document.querySelector<HTMLLinkElement>("link[rel='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.href = faviconUrl;
}

export function usePublicBranding(options: PublicBrandingOptions) {
  const { title, faviconUrl } = options;
  useEffect(() => {
    applyPublicBranding({ title, faviconUrl });
  }, [faviconUrl, title]);
}
